
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {translate} from 'react-i18next'
import {withStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

import Results from './Results'

import StyledPaper from '../StyledPaper'

const mainPieColor = '#569BCA'
const secondaryPieColor = '#EDECED'

const styles = theme => ({
  body1: {
    color: '#8e8f90',
    fontSize: '1.125rem'
  },
  button: {
    backgroundColor: 'inherit',
    border: '1px solid #569bca',
    color: '#569bca',
    marginTop: '20px'
  },
  fullWidth: {
    width: '100%'
  },
  moon: {
    maxWidth: '100%',
    height: 'auto'
  },
  moonContainer: {
    marginTop: theme.spacing.unit * 2
  },
  legendDescription: {
    paddingLeft: 20
  },
  legendEntry: {
    marginTop: 25
  },
  legendKey: {
    display: 'inline-block',
    border: '1px solid #569bca',
    height: 15,
    width: 15,
    marginRight: 5
  },
  legendLabel: {
    fontWeight: 'bolder',
    textTransform: 'uppercase',
    verticalAlign: 'text-bottom'
  },
  spacer: {
    marginTop: theme.spacing.unit * 3
  },
  topFactors: {
    backgroundColor: '#f2f5f9',
    '& > *': {
      color: '#646464'
    }
  }
})

export class Report extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userComments: this.props.userComments,
      emailContent: '',
      emailRecipients: '',
      likelyOption: this.props.setLikelyOption()
    }
    this.emailRecipientsInputField = React.createRef()
  }

  addEmailFieldDataToParentState(event) {
    const { name, value } = event.target
    this.props.addEmailFieldDataToParentState(name, value)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFocusOnEmailRecipients !== this.props.isFocusOnEmailRecipients) {
      this.emailRecipientsInputField.focus()
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      userComments: nextProps.userComments,
      likelyOption: this.props.setLikelyOption()
    });
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  handleKeyUp = () => {
    this.props.areAllEmailRecipientsValid(this.state.emailRecipients)
  }

  showPercentage(percentage) {
    if (percentage >= 85) {
      return "\u2265 85"
    } else if (percentage <= 15) {
      return "\u2264 15"
    } else {
      return percentage
    }
  }

  render() {
    const {classes, t} = this.props
    return (
      <Grid container justify="center" >
        <Grid item xs={12}>

          <Typography
            className={`${classes.spacer} ${classes.body1}`}
            variant="body1"
          >
            A. {t('Preference For Options')}
          </Typography>
        </Grid>
        <Grid
          className={classes.moonContainer}
          container
          item
          xs={12}
          justify='space-between'
        >
            {this.renderBarResult()}
        </Grid>
        <Grid container>
          <Grid item xs={10}>
            <Typography
              className={`${classes.spacer} ${classes.body1}`}
              variant="body1"
            >
              B. {t('Top Factors')}
            </Typography>
          </Grid>

          {!!this.props.topFactorsOptions.option1.length && (
            <React.Fragment>
              <Typography
                className={`${classes.spacer} ${classes.body2}`}
                variant="body2"
              >
                {t('Factors Supporting Option', {OPTIONNUM: 1})}
              </Typography>
              {this.props.topFactorsOptions.option1.map(factor => (
                <Grid item xs={12} key={factor}>
                  <StyledPaper className={`${classes.spacer} ${classes.topFactors}`}>
                    <Typography>{factor}</Typography>
                  </StyledPaper>
                </Grid>
              ))}
            </React.Fragment>
          )}

          {!!this.props.topFactorsOptions.option2.length && (
            <React.Fragment>
              <Typography
                className={`${classes.spacer} ${classes.body2}`}
                variant="body2"
              >
                {t('Factors Supporting Option', {OPTIONNUM: 2})}
              </Typography>
              {this.props.topFactorsOptions.option2.map(factor => (
                <Grid item xs={12} key={factor}>
                  <StyledPaper className={`${classes.spacer} ${classes.topFactors}`}>
                    <Typography>{factor}</Typography>
                  </StyledPaper>
                </Grid>
              ))}
            </React.Fragment>
          )}

        </Grid>
        <Grid container>
          {this.renderReportForm()}
        </Grid>
      </Grid>
    )
  }

  sendEmail() {
    this.props.sendEmail()

    this.setState({
      emailContent: '',
      emailRecipients: '',
    })
  }

  renderReportForm() {
    const {classes, counselor, t, isCounselingSessionDisabled} = this.props
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Typography  className={`${classes.spacer} ${classes.body1}`} variant="body1">
            <label htmlFor="counselor-comments">
              C. {t('Comments')}
            </label>
          </Typography>
          <TextField
            className={classes.fullWidth}
            id="counselor-comments"
            multiline
            name="userComments"
            onChange={this.handleChange.bind(this)}
            value={this.state.userComments}
            onBlur={event => this.props.updateUserComments(event.target.value)}
            disabled={isCounselingSessionDisabled}
          />
        </Grid>
        {/* Counselor */}
        <Grid item xs={12}>
          <Typography className={`${classes.spacer} ${classes.body1}`} variant="body1">
            {t('Decision Counselor')}
          </Typography>
          <Typography variant="body2">
            {counselor}
          </Typography>
        </Grid>
        {/* Email Recipients */}
        <Grid item xs={12}>
          <Typography className={`${classes.spacer} ${classes.body1}`} variant="body1">
            <label htmlFor="email-recipients">
              {t('Email Recipients')}
            </label>
          </Typography>
          <TextField
            className={classes.fullWidth}
            id="email-recipients"
            inputRef={el => this.emailRecipientsInputField = el}
            name="emailRecipients"
            onBlur={this.addEmailFieldDataToParentState.bind(this)}
            onChange={this.handleChange.bind(this)}
            onKeyUp={this.handleKeyUp}
            value={this.state.emailRecipients}
          />
        </Grid>
        {/* Email Content */}
        <Grid item xs={12} style={{marginBottom: 40}}>
          <Typography
            className={`${classes.spacer} ${classes.body1}`}
            variant="body1"
          >
            <label htmlFor="email-content">
              {t('Email Content')}
            </label>
          </Typography>
          <TextField
            className={classes.fullWidth}
            id="email-content"
            multiline
            name="emailContent"
            onBlur={this.addEmailFieldDataToParentState.bind(this)}
            onChange={this.handleChange.bind(this)}
            value={this.state.emailContent}
          />
          <Grid container justify="flex-end">
            <Grid item>
              <Button variant="contained" className={classes.button} onClick={() => this.sendEmail()}>
                {t('Send Email')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }

  renderBarResult() {
    const {finalWeight, optionsArray: options} = this.props
    const finalWeightAsPercentage = finalWeight * 100

    return (
      <Results
        optionOnePercentage={finalWeightAsPercentage}
        optionOne={`${options[0]}`}
        optionTwo={`${options[1]}`}
      />
    )
  }

  renderMoonLegend() {
    const {classes, finalWeight, t, optionsArray: options} = this.props
    const finalWeightAsPercentage = finalWeight * 100

    return (
      <Grid container direction="column">
        <Grid className={classes.legendEntry} item xs>
          <Typography variant="body1">
            <span
              className={classes.legendKey}
              style={{backgroundColor: secondaryPieColor}}
            >
            </span>
            <span className={classes.legendLabel}>
              {t('Option', {OPTIONNUM: 1})} ({this.showPercentage(Math.round(finalWeightAsPercentage))}%)
            </span>
          </Typography>
          <Typography className={classes.legendDescription}>
            {options[0]}
          </Typography>
        </Grid>
        <Grid className={classes.legendEntry} item xs>
          <Typography variant="body1">
            <span
              className={classes.legendKey}
              style={{backgroundColor: mainPieColor}}
            >
            </span>
            <span className={classes.legendLabel}>
              {t('Option', {OPTIONNUM: 2})} ({this.showPercentage(Math.round(100 - finalWeightAsPercentage))}%)
            </span>
          </Typography>
          <Typography className={classes.legendDescription}>
            {options[1]}
          </Typography>
        </Grid>
      </Grid>

    )
  }
}

Report.propTypes = {
  addEmailFieldDataToParentState: PropTypes.func.isRequired,
  areAllEmailRecipientsValid: PropTypes.func.isRequired,
  counselor: PropTypes.string.isRequired,
  decisionName: PropTypes.string.isRequired,
  finalWeight: PropTypes.number.isRequired,
  isFocusOnEmailRecipients: PropTypes.bool.isRequired,
  optionsArray: PropTypes.array.isRequired,
  setLikelyOption: PropTypes.func.isRequired,
  topFactorsOptions: PropTypes.object,
  userComments: PropTypes.string.isRequired,
  sendEmail: PropTypes.func.isRequired,
}

export default compose(
  translate(),
  withStyles(styles)
)(Report)


// WEBPACK FOOTER //
// ./src/components/counseling-session/report/Report.js